export const ReportUrl = {
  // Report
  // get all pre-reserve by status
  GetAllByStatus: '/PreReserve/PreReserveQuery/GetPreReserveByStatus',
  // Get Pre-reserve Paid Stat
  GetPreReservPaid: '/PreReserve/PreReserveQuery/GetPreReservePaidStatReportByDate',
  // Get Pre-reserve Paid Stat Details
  GetPreReservPaidDetails: '/PreReserve/PreReserveQuery/GetPreReservePaidDetailReportByDate',
  // Get Pre-reserve Not Paid Stat
  GetPreReservNotPaid: '/PreReserve/PreReserveQuery/GetPreReserveNotPaidStatReportByDate',
  // Get Pre-reserve Not Paid Stat Details
  GetPreReservNotPaidDetails: '/PreReserve/PreReserveQuery/GetPreReserveNotPaidDetailReportByDate',
  // Get Pre-reserve Canceled Stat
  GetPreReservCanceled: '/PreReserve/PreReserveQuery/GetPreReserveCanceledStatReportByDate',
  // Get Pre-reserve Canceled Stat Details
  GetPreReservCanceledDetails:
    '/PreReserve/PreReserveQuery/GetPreReserveCanceledDetailReportByDate',
  // Get Pre-reserve  Stat
  GetPreReservStat: '/PreReserve/PreReserveQuery/GetPreReserveStatReportByDate',
  // GetPayment
  GetPayment: '/PreReserve/PaymentQuery/GetPaymentDetailsByDate',
  // Get Sajaya Relation State
  GetSajayaRelationStat: '/PreReserve/PreReserveQuery/GetPreReserveRelationStatReportByDate',
  // Get Citites State
  GetCitiesStatByProviceId: '/PreReserve/PreReserveQuery/GetPreReserveProvinceCityStatReportByDate',
}
